import { styled } from '@mui/material'
import Tooltip, { TooltipProps } from '@mui/material/Tooltip'
import { memo } from 'react'
import { IconInfo } from 'components/Icons'

interface IconfontData {
  title?: string
  size?: number
  placement?: TooltipProps['placement']
}

const IconWrap = styled('span')<{
  $size?: number
}>`
  line-height: 0;
`
const IconHelp = memo<IconfontData>(({ title, size, placement = 'bottom' }) => {
  return (
    <Tooltip title={title} arrow placement={placement}>
      <IconWrap>
        <IconInfo />
      </IconWrap>
    </Tooltip>
  )
})

export default IconHelp
